<template>
    <div class="live-info-card">
        <div class="card">
            <img class="cover" :src="cover" />
            <div
                v-if="liveInfo"
                :class="[
                    'btn',
                    {
                        withoutTime: [LIVE_STATUS.ENDED_WITHOUT_RECORDING, LIVE_STATUS.NOT_AVAILABLE].includes(
                            liveStatus
                        )
                    }
                ]"
            >
                <span class="time">{{ liveTime }}</span>
                <a v-if="liveStatus === LIVE_STATUS.UNSUBSCRIBED" class="book" @click="subscribe">{{ t('book') }}</a>
                <a v-else-if="liveStatus === LIVE_STATUS.SUBSCRIBED" class="booked" @click="cancelSubscribe">{{
                    t('booked')
                }}</a>
                <a v-else-if="liveStatus === LIVE_STATUS.WAITING_START" class="waiting">{{ t('startSoon') }}</a>
                <a v-else-if="liveStatus === LIVE_STATUS.ON_LIVING" class="live" :href="liveLink">{{ t('live') }}</a>
                <a v-else-if="liveStatus === LIVE_STATUS.ENDED_WITHOUT_RECORDING" class="ended">{{ t('ended') }}</a>
                <a v-else-if="liveStatus === LIVE_STATUS.ENDED_WITH_RECORDING" class="replay" :href="liveLink">{{
                    t('replay')
                }}</a>
                <a v-else-if="liveStatus === LIVE_STATUS.NOT_AVAILABLE" class="canceled">{{ t('cancelled') }}</a>
            </div>
        </div>
    </div>
</template>
<script>
import { PLATFORM, LIVE_STATUS, getLiveLink, getCommunityLink } from './constants/business';
import { isLogin, toLogin, getEntity } from './utils';
import Toast from '@futuweb/fego-render/src/utils/toast.js';
import FegoRender from '@futuweb/fego-render';
import { ToolDateFormatter, TEMPLATE_YMD, TEMPLATE_HMS } from '@futuweb/tool-date-formatter';
const { useI18n } = require('@fegobull/webapi').use;
import lang from './constants/lang';

let commonApiLiveInfoCard = null;
if (FegoRender) {
    const { request } = FegoRender.common;
    commonApiLiveInfoCard = request.bindCommonApi('live-info-card');
}

const toolDateFormatter = new ToolDateFormatter({
    entity: getEntity()
});

export default {
    name: 'live-info-card',
    props: {
        // 预告id
        announceId: {
            type: [String, Number],
            default: ''
        },
        // 封面
        cover: {
            type: String,
            default: ''
        },
        // 平台
        platform: {
            type: String,
            default: PLATFORM.MOOMOO
        },
        // 语言
        lang: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            LIVE_STATUS,
            liveInfo: null,
            t: useI18n(lang, this.$props.lang)
        };
    },
    computed: {
        liveLink() {
            if (!this.liveInfo) {
                return '';
            }
            const { studioId, studioFeedId } = this.liveInfo;

            let link = '';
            if (this.liveStatus === LIVE_STATUS.ON_LIVING) {
                if (studioId) {
                    // 跳直播间
                    link = getLiveLink({
                        platform: this.platform,
                        studioId
                    });
                }
            } else {
                if (studioFeedId) {
                    // 跳社区
                    link = getCommunityLink({
                        platform: this.platform,
                        studioFeedId
                    });
                }
            }
            return link;
        },
        liveStatus() {
            if (this.liveInfo) {
                return this.liveInfo.announceStatus;
            }
            return '';
        },
        liveTime() {
            if (!this.liveInfo) {
                return '';
            }
            const { announceTime } = this.liveInfo;
            const formatted = toolDateFormatter.dateFormatByTemplate({
                dateTemplateArr: [TEMPLATE_YMD.YEAR_MONTH_DAY, TEMPLATE_HMS.HOUR_MINUTE_SECOND],
                timestamps: announceTime * 1e3,
                lang: this.lang
            });
            return formatted;
        }
    },
    watch: {
        announceId: {
            immediate: true,
            handler(value) {
                if (!value) {
                    this.liveInfo = null;
                    return;
                }
                this.getLiveInfo();
            }
        }
    },
    methods: {
        /**
         * 获取直播信息
         */
        async getLiveInfo() {
            if (!FegoRender || !this.announceId) {
                return;
            }
            const liveInfo = await commonApiLiveInfoCard.get(`getLiveInfo`, {
                announce_id: this.announceId
            });
            if (liveInfo) {
                this.liveInfo = liveInfo;
            }
        },

        /**
         * 预约直播
         */
        async subscribe() {
            if (!FegoRender) {
                return;
            }
            if (!isLogin) {
                toLogin(this);
                return;
            }

            let liveInfo = null;
            try {
                liveInfo = await commonApiLiveInfoCard.post(`subscribe`, {
                    announce_id: this.announceId
                });
            } catch (e) {
                console.error(e);
            }
            if (liveInfo) {
                this.liveInfo.announceStatus = liveInfo.announceStatus;
                Toast.tips(this.t('bookedTips'));
            } else {
                Toast.tips(this.t('bookedErrorTips'));
            }
        },

        /**
         * 取消预约直播
         */
        async cancelSubscribe() {
            if (!FegoRender) {
                return;
            }
            if (!isLogin) {
                toLogin(this);
                return;
            }

            let liveInfo = null;
            try {
                liveInfo = await commonApiLiveInfoCard.post(`cancelSubscribe`, {
                    announce_id: this.announceId
                });
            } catch (e) {
                console.error(e);
            }
            if (liveInfo) {
                this.liveInfo.announceStatus = liveInfo.announceStatus;
                Toast.tips(this.t('bookCancelTips'));
            } else {
                Toast.tips(this.t('bookCancelErrorTips'));
            }
        }
    }
};
</script>
<style lang="less" scoped>
.card {
    margin: 0 auto;
    position: relative;
    // width: 6.7rem;
    // height: 3.78rem;
    height: 100%;
    border-radius: 0.2rem;
    overflow: hidden;
    .cover {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .btn {
        position: absolute;
        bottom: 0.36rem;
        right: 0.32rem;
        border-radius: 0.28rem;
        padding-left: 0.23rem;
        display: flex;
        align-items: center;
        line-height: 0.52rem;
        background-color: rgba(0, 0, 0, 0.5);
        .time {
            margin-right: 0.13rem;
            font-size: 0.28rem;
            color: #fff;
        }
        &.withoutTime {
            padding-left: 0;
            .time {
                display: none;
            }
        }
        a {
            padding: 0 0.2rem 0 0.57rem;
            border-radius: 0.28rem;
            border: 0.02rem solid #f09c47;
            background-color: #f09c47;
            background-image: linear-gradient(0deg, rgb(240, 156, 71) 0%, rgb(236, 115, 48) 100%);
            font-size: 0.3rem;
            line-height: 0.52rem;
            color: #fff;
            position: relative;
            &::before {
                display: inline-block;
                content: '';
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: 0.25rem;
                background-position: center;
                background-size: 100%;
                background-repeat: no-repeat;
            }
            &.book {
                padding-left: 0.63rem;
                &::before {
                    left: 0.24rem;
                    width: 0.3rem;
                    height: 0.3rem;
                    background-image: url('./images/time.png');
                }
            }
            &.booked {
                padding-left: 0.62rem;
                background-color: transparent;
                background-image: none;
                color: #f09c47;
                &::before {
                    left: 0.25rem;
                    width: 0.3rem;
                    height: 0.3rem;
                    background-image: url('./images/right.png');
                }
            }
            &.live {
                padding-left: 0.75rem;
                &::before {
                    left: 0.3rem;
                    width: 0.32rem;
                    height: 0.32rem;
                    background-image: url('./images/video.png');
                }
            }
            &.replay {
                padding-left: 0.2rem;
            }
            &.waiting {
                padding-left: 0.2rem;
            }
            &.ended,
            &.canceled {
                padding-left: 0.2rem;
            }
        }
    }
}
</style>
